import { render } from "./products-pricing-page.vue?vue&type=template&id=75e28b46"
import script from "./products-pricing-page.vue?vue&type=script&lang=js"
export * from "./products-pricing-page.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__